export {TrashCard} from './TrashCard';
export {DefiShildTrashComponent} from './DefiShildTrash';
export {LightNFTTrash} from './LightNFTTrash';
export {WalletsShieldTrash} from './WalletsShieldTrash';
export {LightDeFiTrashComponent} from './LightDeFiTrash';
export {PartnerGuardTrash} from './PartnerGuardTrash';